<template>
  <el-dialog class="dialog-change-topic" title="上传专题" v-bind="$attrs" width="400px" @close="close">
    <el-form ref="form" label-width="100px" :model="formData" :rules="rules">
      <el-form-item label="选择父专题">
        <el-select v-model="formData.parentSectionId" placeholder="请选择父专题" size="small" clearable>
          <el-option v-for="(section, index) in sections" :key="index" :label="section.moduleName" :value="section.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择子专题" prop="sectionId">
        <el-select v-model="formData.sectionId" no-data-text="请先选择父专题" placeholder="请选择子专题" size="small" clearable>
          <el-option v-for="(subSection, index) in subSections" :key="index" :label="subSection.sectionName"
            :value="subSection.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'TwitterAdminClientDialogChangeTopic',
  emit: ['close'],
  props: {
    sections: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      formData: {
        parentSectionId: '',
        sectionId: '',
      },
      rules: {
        sectionId: [{ required: true, message: '请选择子专题' }]
      }
    };
  },
  computed: {
    subSections() {
      const currentSection = this.sections.find(v => v.id === this.formData.parentSectionId)
      if (currentSection) {
        return currentSection.allSection
      }
      return []
    }
  },
  watch: {
    'formData.parentSectionId': {
      handler() {
        this.formData.sectionId = ''
      }
    }
  },
  mounted() {

  },

  methods: {
    close() {
      this.$emit('close')
    },
    sure() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('sure', this.formData.sectionId)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-change-topic {
  /deep/ .el-form-item__error {
    margin-left: 100px;
  }
}
</style>
